import { useMutation } from '@tanstack/react-query';
import { PartnerFavoriteSave, RequestData } from '../types/types';
import { callPublicAPI } from '../utils/api';

export const useSaveSelectedPartnersMutation = (
  selectedPartners: string[],
  handleSavedSelectedPartners: () => void,
  handleFailedToSaveSelectedPartners: () => void
) => {
  return useMutation({
    mutationFn: async () => {
      const data: RequestData = {
        partners: selectedPartners
      };

      const response = await callPublicAPI<PartnerFavoriteSave>('POST', `/user-selected-partners`, null, data);
      return response.data;
    },
    onSuccess: handleSavedSelectedPartners,
    onError: handleFailedToSaveSelectedPartners
  });
};
